function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUddp(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#231815",
    d: "M81.977 37.079c-4.644 0-8.615 2.901-10.218 6.982H65.63v2.592c-.613-7.644-6.149-13.906-13.434-15.619v-6.542c4.081-1.604 6.982-5.574 6.982-10.218 0-6.056-4.927-10.982-10.983-10.982-6.056 0-10.982 4.927-10.982 10.982 0 4.644 2.901 8.614 6.982 10.218v6.542A17.54 17.54 0 0031.169 44.06h-5.643c-1.604-4.081-5.574-6.982-10.218-6.982-6.056 0-10.982 4.927-10.982 10.982s4.927 10.982 10.982 10.982c4.644 0 8.614-2.901 10.218-6.982h5.643a17.542 17.542 0 0013.026 13.027v6.209c-4.081 1.604-6.982 5.574-6.982 10.217 0 6.056 4.927 10.982 10.982 10.982 6.056 0 10.983-4.927 10.983-10.982 0-4.643-2.901-8.613-6.982-10.217v-6.209c7.284-1.712 12.821-7.975 13.434-15.619v2.592h6.129c1.604 4.081 5.574 6.982 10.218 6.982 6.056 0 10.982-4.927 10.982-10.982s-4.927-10.981-10.982-10.981zM15.308 51.044c-1.645 0-2.982-1.338-2.982-2.982s1.338-2.982 2.982-2.982c1.26 0 2.334.788 2.771 1.894v2.176a2.984 2.984 0 01-2.771 1.894zm32.887-39.751a2.986 2.986 0 012.983 2.982 2.986 2.986 0 01-2.983 2.983 2.985 2.985 0 01-2.982-2.983 2.984 2.984 0 012.982-2.982zm0 73.204c-1.645 0-2.982-1.338-2.982-2.982s1.338-2.982 2.982-2.982c1.645 0 2.983 1.338 2.983 2.982s-1.338 2.982-2.983 2.982zm0-26.93c-5.241 0-9.505-4.265-9.505-9.506s4.264-9.505 9.505-9.505c5.242 0 9.505 4.264 9.505 9.505s-4.263 9.506-9.505 9.506zm33.782-6.523c-1.646 0-2.983-1.338-2.983-2.982s1.338-2.982 2.983-2.982 2.982 1.338 2.982 2.982-1.338 2.982-2.982 2.982z"
  }));
}

SvgUddp.clsName = 'icon-www__uddp';
SvgUddp.remarkName = 'unknown';
export default SvgUddp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Uddp.js
// module id = 2462
// module chunks = 17 18